import { DomSanitizer } from '@angular/platform-browser';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Component, ViewChild, TemplateRef, Inject, OnDestroy } from '@angular/core';
import { ClaveUnicaService } from 'src/app/services/clave_unica.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';


declare const swal: any;
@Component({
    selector: "page-claveunica",
    templateUrl: "./claveunica.component.html",
    styleUrls: ["./claveunica.component.css"],
    providers: [ClaveUnicaService]
})

export class ClaveUnicaComponent implements OnDestroy {

    @ViewChild('modalClaveUnica') modalClaveUnica: TemplateRef<any>;
    @ViewChild('modalClaveUnicaIFrame') modalClaveUnicaIFrame: TemplateRef<any>;
    public safeUrl
    public identity
    private authWindow: Window | null = null;

    constructor(
        private dialog: MatDialog,
        private claveUnicaService: ClaveUnicaService,
        private spinner: NgxSpinnerService,
        private _router: Router,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        console.log("DATA", data);


    }

    ngOnDestroy(): void {
        // Remover el listener cuando se destruye el componente
        window.removeEventListener('message', this.handleMessage.bind(this));

        // Cerrar la ventana si aún está abierta (opcional)
        if (this.authWindow) {
            this.authWindow.close();
        }
    }

    isListenerActive = false;

    claveunica() {
        this.spinner.show()
        this.claveUnicaService.getToken().subscribe(response => {
            const externalUrl = response.url;
            console.log("External url: ", externalUrl);
            const urlObj = new URL(externalUrl);

            const state = urlObj.searchParams.get('state');
            localStorage.setItem('authState', state);

            this.authWindow = window.open(externalUrl, '_blank');

            if (!this.isListenerActive) {
                window.addEventListener('message', this.handleMessage.bind(this));
                this.isListenerActive = true;
            }

        });



    }

    handleMessage(event: MessageEvent): void {
        if (event.origin !== 'https://muniptealto-develop.solnet.cl') {
            return; // Ignorar mensajes de orígenes no deseados
        }

        const { code, state } = event.data;
        console.log('Datos recibidos');
        localStorage.setItem('authParams', JSON.stringify({ code, state }));

        window.removeEventListener('message', this.handleMessage.bind(this))
        this.isListenerActive = false;

        const storedState = localStorage.getItem('authState');
        if (state === storedState) {
            this.claveUnicaService.getInfoCiudadano(code, state).subscribe(response => {
                if (response) {
                    let identityjson = {
                        "active": true,
                        "apellidoM": response.name?.apellidos[1],
                        "apellidoP": response.name?.apellidos[0],
                        "dv": response.RolUnico?.DV,
                        "email": '-',
                        "nombres": response.name?.nombres[0] + " " + response.name?.nombres[1],
                        "rut": response.RolUnico?.numero,
                        "telefono": '-'
                    }
                    sessionStorage.setItem('identity-domCloud', JSON.stringify(identityjson));

                    if (this.authWindow) {
                        this.authWindow.close();
                        this.authWindow = null;
                    }


                    this.dialog.closeAll()
                    this.spinner.hide()
                    this._router.navigate([this.data]);

                    /*    swal({
                           type: "success",
                           title: 'Autenticación exitosa',
                           text: '<p>Se logró validar su indentidad, puede continuar con los servicios solicitados.</p>',
                           confirmButtonColor: "#3F51B5",
                           showConfirmButton: true,
                           confirmButtonText: 'Aceptar',
                           allowOutsideClick: false
                       }) */



                }
            });

        } else {
            console.error('State no coincide, posible ataque CSRF');
        }
    }

}